import {Box, Card, CardContent, Typography} from '@mui/material';
import {useLocation} from 'react-router-dom';
import {FeedbackContext} from '../../models/Feedback';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import FeedbackForm from './FeedbackForm';

export default function FeedbackPage() {
    const {t} = useAppTranslation();
    const location = useLocation();
    const context = (location.state as {feedbackContext?: FeedbackContext} | null)?.feedbackContext;
    return <Box sx={{width: '100%', py: {xs: 1, sm: 3}}}>
        <Typography component="h1" variant="h2" sx={{mb: 1}}>{t('feedback:title' as never)}</Typography>
        <Typography color="text.secondary" sx={{mb: 3}}>{t('feedback:subtitle' as never)}</Typography>
        <Card variant="outlined"><CardContent sx={{p: {xs: 2, sm: 3}}}><FeedbackForm context={context}/></CardContent></Card>
    </Box>;
}
